import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useFormik } from "formik";
import { Link, useNavigate } from "react-router-dom";
import * as Yup from "yup";
import api from "../../../config/URL";
import { toast } from "react-toastify";
import SignatureCanvas from "react-signature-canvas";
import CustomDatePicker from "../../CustomDatePicker";
import { format } from "date-fns";

const validationSchema = Yup.object().shape({
  termsAndConditionSignatureDate: Yup.string().required(
    "*Signature Date is required"
  ),
  agree: Yup.boolean()
    .oneOf([true], "*You Must Accept Terms and conditions is required")
    .required("*You Must Accept Terms and conditions is required"),
});

const AddTermsAndCondition = forwardRef(
  ({ formData, setLoadIndicators, setFormData, handleNext }, ref) => {
    const navigate = useNavigate();
    const userName = localStorage.getItem("userName");

    const [sign, setSign] = useState();
    const [url, setUrl] = useState();

    const handleClear = () => {
      sign.clear();
      setUrl("");
    };

    const handleGenerate = () => {
      setUrl(sign.getTrimmedCanvas().toDataURL("image/png"));
      console.log("Sign :", sign);
    };

    const formik = useFormik({
      initialValues: {
        file: null || "",
        termsAndConditionSignatureDate:
          formData.termsAndConditionSignatureDate ||
          format(new Date(), "yyyy-MM-dd"), // Set current date as default
        agree: formData.agree || false, // Ensure agree defaults to false
      },
      validationSchema: validationSchema,
      onSubmit: async (data) => {
        setLoadIndicators(true);
        const formDatas = new FormData();

        // Check if the URL (signature) exists
        if (!url) {
          formDatas.append("file", "");
        } else {
          const randomNumber = Math.floor(Math.random() * 1000);
          const apiResponse = await fetch(url);
          const blob = await apiResponse.blob();
          formDatas.append("file", blob, `${randomNumber}Signature.png`);
        }
        formDatas.append(
          "termsAndConditionSignatureDate",
          data.termsAndConditionSignatureDate
        );
        formDatas.append("agree", data.agree);
        formDatas.append("studentDetailId", formData.student_id);
        formDatas.append("createdBy", userName);

        try {
          const response = await api.post(
            `/createStudentTermsAndConditions`,
            formDatas,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );
          if (response.status === 201) {
            toast.success(response.data.message);
            setFormData((prev) => ({ ...prev, ...data }));
            const studentId = formData.student_id;
            navigate(`/invoice/add?studentID=${studentId}`);
            if (formData.LeadId) {
              try {
                const response = await api.put(
                  `/updateLeadInfo/${formData.LeadId}`,
                  {
                    leadStatus: formData.LeadStatus,
                  }
                );
                if (response.status === 200) {
                  console.log("Lead Status CONFIRMED");
                } else {
                  console.log("Lead Status Not CONFIRMED");
                }
              } catch {
                console.log("Lead Status Not CONFIRMED");
              }
            }
          } else {
            toast.error(response.data.message);
          }
          // Trigger the second API call to update referral lead info
          if (formData.LeadId) {
            try {
              const referralResponse = await api.put(
                `/updateLeadInfoForReferral/${formData.LeadId}`,
                {
                  headers: {
                    "Content-Type": "application/json",
                  },
                }
              );
              if (referralResponse.status === 200) {
                console.log("Referral Lead Info UPDATED");
              } else {
                console.log("Referral Lead Info NOT UPDATED");
              }
            } catch (error) {
              console.log("Error updating Referral Lead Info", error);
            }
          }
        } catch (error) {
          toast.error(error.message || "An error occurred");
        } finally {
          setLoadIndicators(false);
        }
      },
      validateOnChange: false,
      validateOnBlur: true,
    });

    // Function to scroll to the first error field
    const scrollToError = (errors) => {
      const errorField = Object.keys(errors)[0];
      const errorElement = document.querySelector(`[name="${errorField}"]`);
      if (errorElement) {
        errorElement.scrollIntoView({ behavior: "smooth", block: "center" });
        errorElement.focus();
      }
    };

    useEffect(() => {
      if (formik.submitCount > 0 && Object.keys(formik.errors).length > 0) {
        scrollToError(formik.errors);
      }
    }, [formik.submitCount, formik.errors]);

    useImperativeHandle(ref, () => ({
      TermsAndCondition: formik.handleSubmit,
    }));

    return (
      <div className="container-fluid">
        <form
          onSubmit={formik.handleSubmit}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !formik.isSubmitting) {
              e.preventDefault();
            }
          }}
        >
          <div className="border-0 mb-5">
            <div className="mb-5 ">
              <div className="border-0 my-2 px-2">
                <p className="headColor">Terms & Condition</p>
                <div className="container py-3">
                  <div className="row">
                    <div className="col-md-6 col-12">
                      <div className="text-start mt-3">
                        <label htmlFor="" className="mb-1 fw-medium">
                          <small>Parent Signature</small>
                        </label>
                        <br />
                        <div
                          style={{
                            width: 423,
                            height: 150,
                          }}
                          className="border border-secondary rounded-2"
                        >
                          <SignatureCanvas
                            canvasProps={{
                              width: 423,
                              height: 150,
                              className: "sigCanvas",
                            }}
                            name="file"
                            ref={(data) => setSign(data)}
                          />
                        </div>
                        <br />
                        <button
                          type="button"
                          style={{ height: "30px", width: "60px" }}
                          onClick={handleClear}
                          className="btn btn-sm"
                        >
                          Clear
                        </button>
                        <button
                          type="button"
                          style={{ height: "30px", width: "60px" }}
                          onClick={handleGenerate}
                          className="btn btn-sm"
                        >
                          Save
                        </button>
                        <br />
                        <br />
                        {url && <img src={url} alt="Signature" />}
                      </div>
                    </div>
                    <div className="col-md-6 col-12">
                      <div className="text-start mt-2">
                        <label className="mb-1 fw-medium">
                          <small>
                            Signature Date<span className="text-danger">*</span>
                          </small>
                        </label>
                        <br />
                        <CustomDatePicker
                          name="termsAndConditionSignatureDate"
                          value={
                            formik.values.termsAndConditionSignatureDate
                              ? new Date(
                                  formik.values.termsAndConditionSignatureDate
                                )
                              : new Date() // Set current date as default
                          }
                          onChange={(date) =>
                            formik.setFieldValue(
                              "termsAndConditionSignatureDate",
                              date ? format(date, "yyyy-MM-dd") : ""
                            )
                          }
                          onBlur={formik.handleBlur}
                          error={formik.errors.termsAndConditionSignatureDate}
                          touched={
                            formik.touched.termsAndConditionSignatureDate
                          }
                          dateFormat="yyyy-MM-dd"
                        />
                        {formik.touched.termsAndConditionSignatureDate &&
                          formik.errors.termsAndConditionSignatureDate && (
                            <div className="error text-danger">
                              {formik.errors.termsAndConditionSignatureDate}
                            </div>
                          )}
                      </div>
                    </div>
                  </div>
                  <div className="mt-3">
                    <input
                      className="form-check-input me-2"
                      type="checkbox"
                      name="agree"
                      checked={formik.values.agree}
                      onChange={(e) => {
                        const newValue = e.target.checked;
                        formik.setFieldValue("agree", newValue);
                      }}
                      onBlur={formik.handleBlur}
                    />
                    <small>
                      By submitting this form, I confirm that I have read and
                      agree to Arty Learning's
                      <Link
                        to="/termsAndCondition"
                        target="_blank"
                        style={{ color: "#ff7500" }}
                        className="ms-1"
                      >
                        Terms & Conditions.
                      </Link>
                    </small>
                    {formik.touched.agree && formik.errors.agree && (
                      <div className="text-danger">
                        <small>{formik.errors.agree}</small>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    );
  }
);

export default AddTermsAndCondition;
